import { setLoginStatus } from "./login-status";

class LoginSuccess extends HTMLElement {
    connectedCallback() {
        this.email = this.getAttribute('email');
        this.appCallback = this.getAttribute('callback-src') || "";
        this.redirectUrl = this.getAttribute('redirect-url') || "";
        this.domainLogin = this.getAttribute('domain-login') || false;
        setLoginStatus(true, this.email);

        if (this.domainLogin) {
            window.location.replace(this.redirectUrl);
        } else {
            const callbackApp = `<callback-app src="${this.appCallback}" redirect-after-callback="${this.redirectUrl}"></callback-app>`;
            this.insertAdjacentHTML("afterend", callbackApp);
        }
    }
}
customElements.define('login-success', LoginSuccess);